import {Observable} from "rxjs";

export abstract class FavoriteDoorService {
  abstract loadFavoriteDoorCount(): void;
  abstract toggleFavorite(doorId: string, customerKey: string): Promise<boolean>;
  abstract getFavoriteDoorCount(customerKey: string): Observable<number>;
}
